import React, { Component } from "react";
import { StyledMarkerplaceHelpText, HomeTitleRow } from "./stylesHome";
import axios from "axios";
import { Box, Flex, Heading } from "@chakra-ui/react";

class TldrTitleRow extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { classes, titleComponent, title, subTitle } = this.props;

    return (
      <HomeTitleRow className={`${classes ? classes : ""}`}>
        <Flex direction="column" align="flex-start">
          {titleComponent || (
            <Heading as="h4" className="title" textAlign="center" fontWeight="bold">
              {title}
            </Heading>
          )}

          {subTitle ? (
            <Box
              as={StyledMarkerplaceHelpText}
              display={["none", "block", "block", "block"]}
            >
              {subTitle}
            </Box>
          ) : null}
        </Flex>
       </HomeTitleRow>
    );
  }
}

export default TldrTitleRow;
